if (!document.getElementById('everloop-gallery-css')) {
  const st = document.createElement('style');
  st.id = 'everloop-gallery-css';
  st.textContent = '@media screen and (max-width: 749px){media-gallery .product__media-list.slider--mobile{gap:0!important;column-gap:0!important;scroll-snap-type:x mandatory}media-gallery .product__media-list.slider--mobile>.product__media-item{width:100%!important;max-width:100%!important;flex:0 0 100%!important;margin-left:0!important;margin-right:0!important;scroll-snap-align:start}}';
  document.head.appendChild(st);
}
if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.mediaOrder = Array.from(this.querySelectorAll('[id^="GalleryViewer"] [data-media-id]')).map((el) => el.dataset.mediaId);
        this.currentMediaId = this.mediaOrder[0];
        if (!this.elements.thumbnails) return;
        this.prependMedia = this.dataset.disablePrepend != 'true';
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        // Everloop: start on the selected colour (e.g. links with ?variant=)
        try {
          const sel = JSON.parse(document.querySelector('[data-selected-variant]')?.textContent || 'null');
          const sectionId = this.id.replace('MediaGallery-', '').replace('-duplicate', '');
          const startMedia = sel && sel.featured_media && this.elements.viewer.querySelector(`[data-media-id="${sectionId}-${sel.featured_media.id}"]`);
          if (startMedia && startMedia !== this.elements.viewer.querySelector('[data-media-id]')) {
            this.currentMediaId = startMedia.dataset.mediaId;
            requestAnimationFrame(() => {
              this.jumpTo(startMedia.parentElement, startMedia.offsetLeft);
              const t = this.elements.thumbnails.querySelector(`[data-target="${startMedia.dataset.mediaId}"]`);
              if (t) {
                this.elements.thumbnails.querySelectorAll('button').forEach((b) => b.removeAttribute('aria-current'));
                t.querySelector('button').setAttribute('aria-current', true);
                this.jumpTo(this.elements.thumbnails.slider, t.offsetLeft);
              }
            });
          }
        } catch (e) {}
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        if (event.detail.currentElement) this.currentMediaId = event.detail.currentElement.dataset.mediaId;
        this.setActiveThumbnail(thumbnail);
      }

      // Everloop: glide to the selected photo like a carousel (fixed, natural speed; no teleporting).
      smoothTo(scroller, left) {
        if (!scroller) return;
        const start = scroller.scrollLeft;
        const dist = left - start;
        if (Math.abs(dist) < 2) return;
        if (scroller._elRaf) cancelAnimationFrame(scroller._elRaf);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          scroller.scrollLeft = left;
          return;
        }
        const pages = Math.abs(dist) / (scroller.clientWidth || 1);
        const duration = Math.min(950, 420 + pages * 60);
        const snap = scroller.style.scrollSnapType;
        const behavior = scroller.style.scrollBehavior;
        scroller.style.scrollSnapType = 'none';
        scroller.style.scrollBehavior = 'auto';
        const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
        const t0 = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - t0) / duration);
          scroller.scrollLeft = start + dist * ease(p);
          if (p < 1) {
            scroller._elRaf = requestAnimationFrame(tick);
          } else {
            scroller._elRaf = null;
            scroller.style.scrollSnapType = snap;
            scroller.style.scrollBehavior = behavior;
            scroller.dispatchEvent(new Event('scroll'));
          }
        };
        scroller._elRaf = requestAnimationFrame(tick);
      }

      jumpTo(scroller, left) {
        if (!scroller) return;
        const prev = scroller.style.scrollBehavior;
        scroller.style.scrollBehavior = 'auto';
        scroller.scrollLeft = left;
        scroller.style.scrollBehavior = prev;
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend && this.prependMedia) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            this.smoothTo(activeMedia.parentElement, activeMedia.offsetLeft);
          }
          this.currentMediaId = activeMedia.dataset.mediaId;
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({behavior: 'smooth', block: 'nearest'});
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        if ( activeMedia.querySelector('.internal-video--playing video')) {
          activeMedia.querySelector('video').play();

        }
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.smoothTo(this.elements.thumbnails.slider, thumbnail.offsetLeft);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
